// extracted by mini-css-extract-plugin
export var box = "order-details-box-module--box--a13d9";
export var flexGrow = "order-details-box-module--flex-grow--b3c9b";
export var titleText = "order-details-box-module--title-text--ded94";